module.exports = __webpack_public_path__ + "img/softTechnology.541ed77d.jpg";